import { ComexPreset } from '@src/styles/preset/comex.preset';
import { providePrimeNG as originalProvidePrimeNG } from 'primeng/config';

export const providePrimeNG = () =>
  originalProvidePrimeNG({
    theme: {
      preset: ComexPreset,
      options: {
        darkModeSelector: false, // Disable dark mode even if OS prefers it
        cssLayer: {
          name: 'primeng',
          order: 'theme, base, primeng',
        },
      },
    },
    translation: {
      firstDayOfWeek: 1, // Set Monday as the first day of the week
      dateFormat: 'dd/mm/yy',
    },
  });
